import { defineStore } from "pinia";
import router from "../router";
import { useAchievementsStore } from "@stores/achievements";
import { LAUNCH_AT } from "@utils/launch";

export const useGlobalStore = defineStore("global", {
    state: () => ({
        mobile: false,
        modal: {
            name: null,
            payload: null,
            canClose: true,
            fullHeight: false,
        },
        mode: "landing",
        countdown: Date.now() < LAUNCH_AT,
        globeReady: false,
        pendingRoute: null,
        soundOn: true,
        menuOpen: false,
        panels: {
            getStarted: { active: true, hiddenBy: ["clips"] },
            countryInfo: { active: false },
            clips: { active: false },
            trivia: { active: false },
        },
        achievement: {
            active: false,
            title: "",
            description: "",
            icon: "",
        },
    }),

    getters: {
        isPlaying: (state) => state.mode === "playing",
        isLanding: (state) => state.mode === "landing",

        activePage: () => {
            const name = router.currentRoute.value.name;
            return !name || name === "landing" ? "explore" : name;
        },

        panelActive: (state) => (name) => {
            const panel = state.panels[name];
            if (!panel || !panel.active) return false;
            if (panel.hiddenBy?.some((n) => state.panels[n]?.active))
                return false;
            return true;
        },
    },

    actions: {
        setPage(page) {
            router.push({ name: page });
        },

        toggleMobile(delta) {
            delta != null
                ? (this.mobile = delta)
                : (this.mobile = !this.mobile);
        },

        openModal(modal, options = {}) {
            this.modal = {
                name: modal,
                payload: null,
                canClose: true,
                fullHeight: false,
                bare: false,
                ...options,
            };
            document.body.classList.add("overflow-hidden");
        },

        setModal(modal) {
            this.modal = {
                name: modal[0],
                payload: modal[1],
                canClose: modal[2] ?? true,
                fullHeight: modal[3] ?? false,
                bare: modal[4] ?? false,
            };
            document.body.classList.add("overflow-hidden");
        },

        closeModal() {
            this.modal = {
                name: null,
                payload: null,
                canClose: true,
                fullHeight: false,
                bare: false,
            };
            document.body.classList.remove("overflow-hidden");
        },

        startPlaying() {
            this.mode = "playing";
            router.push({ name: "explore" });
            useAchievementsStore().onEnterApp();
        },

        setCountdownDone() {
            this.countdown = false;
        },

        exitToLanding() {
            this.mode = "landing";
            router.push({ name: "landing" });
        },

        toggleSound() {
            this.soundOn = !this.soundOn;
        },

        toggleMenu(value) {
            this.menuOpen = value ?? !this.menuOpen;
        },

        showPanel(name) {
            if (this.panels[name]) this.panels[name].active = true;
        },

        hidePanel(name) {
            if (this.panels[name]) this.panels[name].active = false;
        },

        togglePanel(name) {
            if (this.panels[name])
                this.panels[name].active = !this.panels[name].active;
        },

        showAchievement({ title, description, icon = "" }) {
            this.achievement = { active: true, title, description, icon };
        },

        hideAchievement() {
            this.achievement.active = false;
            useAchievementsStore().advanceToastQueue();
        },

        setGlobeReady() {
            this.globeReady = true;
            if (this.pendingRoute) {
                const route = this.pendingRoute;
                this.pendingRoute = null;
                this.mode = "playing";
                router.push(
                    route === "rules"
                        ? { name: "rules", params: { lang: "en" } }
                        : { name: route },
                );
            }
        },
    },
});
